import * as CHIEFDOM_TYPES from './actionTypes';
import { ChiefdomActions, IChiefdomState } from './types';

export const initialState: IChiefdomState = {
  chiefdomList: [],
  total: 0,
  loading: false,
  error: null
};

const chiefdomReducer = (state = initialState, action = {} as ChiefdomActions): IChiefdomState => {
  switch (action.type) {
    case CHIEFDOM_TYPES.FETCH_CHIEFDOM_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case CHIEFDOM_TYPES.FETCH_CHIEFDOM_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        chiefdomList: action.payload.chiefdomList,
        total: action.payload.total,
        error: null
      };
    case CHIEFDOM_TYPES.FETCH_CHIEFDOM_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case CHIEFDOM_TYPES.CLEAR_CHIEFDOM_LIST:
      return {
        ...state,
        chiefdomList: [],
        total: 0,
        error: null
      };
    default:
      return state;
  }
};

export default chiefdomReducer;
